import { render, staticRenderFns } from "./index-view.vue?vue&type=template&id=06114a9a&scoped=true"
import script from "./index-view.vue?vue&type=script&lang=js"
export * from "./index-view.vue?vue&type=script&lang=js"
import style0 from "./index-view.vue?vue&type=style&index=0&id=06114a9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06114a9a",
  null
  
)

export default component.exports